export default __webpack_public_path__ + "static/media/rhythm.f4f1b17e.png";